export function replaceSingleLetterWords() {
    function replaceInTextNodes(node) {
        node.childNodes.forEach((child) => {
            if (child.nodeType === Node.TEXT_NODE) {
                child.textContent = child.textContent?.replace(/(\s)(i|z|w|do|że|a|at|on|by|for|up|to|o|[0-9])(\s)/gi, "$1$2\u00A0") || "";
            }
            else {
                replaceInTextNodes(child);
            }
        });
    }
    const elements = document.querySelectorAll('p, h1, h2:not(.show-for-sr), h3, h4, h5, h6');
    elements?.forEach((paragraph) => {
        replaceInTextNodes(paragraph);
    });
}
